module.exports = __webpack_public_path__ + "assets/img/2-3.f5076623.png";